import { Layout } from "@/components/layout/Layout";

export function Terms() {
  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 prose prose-neutral dark:prose-invert">
        <p className="text-xs uppercase tracking-widest text-muted-foreground not-prose">Editable placeholder</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-1 not-prose">Terms of use</h1>
        <p className="mt-6 text-foreground/85">
          Play Tsoro is offered &ldquo;as is&rdquo; for personal, non-commercial play and learning. You may not redistribute the
          source code or assets without permission. Cultural references are used respectfully; if anything is incorrect
          we welcome corrections.
        </p>
        <p className="text-foreground/85">
          This placeholder will be replaced with formal terms before production launch.
        </p>
      </article>
    </Layout>
  );
}
